/**
 * Redirects the user to the previous page of Assist that they were on, while avoiding taking the
 * user back to a different website. By default, the user will be redirected to the path of the
 * second parameter if there isn't a previous page on the same site.
 * @param browserBack - Navigate to a previous page, e.g. pass navigate(-1) from React Router.
 * @param systemBack - Navigate to a default path if there is no previous page, e.g. navigate('/').
 */
export const goBack = (browserBack: () => void, systemBack: () => void): void =>
  +(sessionStorage.getItem('backHistory.length') || 0) > 0 ? browserBack() : systemBack();
